<div class="container">
    <div class="informations_status" *ngIf="trackingParcel.deliveryLabel || trackingParcel.optionDeliveryLabel">
        <img class="logo" src="assets/images/picto_livraison_simple.svg" alt="logo livraison" dataqsi="logoLivraison">
        <div class="body">
            <div class="title">{{"bloc-delivery-informations.infos" | translate}}</div>
            <div class="informations" dataqsi="informationText">
                <div>{{trackingParcel.deliveryLabel}}</div>
                <div>{{trackingParcel.optionDeliveryLabel}}</div>
            </div>
        </div>
    </div>
    <div class="informations_delivery" *ngIf="!trackingParcel.removalPoint && !hideReceiverPersonalInfo">
        <img class="logo" src="assets/images/client.svg" alt="logo client" dataqsi="logoClient">
        <div class="body">
            <div class="title">{{"bloc-delivery-informations.home" | translate}}</div>
            <div class="informations">
                <div dataqsi="name">{{trackingParcel.consigneeInformation.name}} {{trackingParcel.consigneeInformation.firstName}}</div>
                <div *ngIf="trackingParcel.consigneeInformation.companyName" dataqsi="companyName">{{trackingParcel.consigneeInformation.companyName}}</div>
                <div dataqsi="address">{{trackingParcel.consigneeInformation.address.address0}} {{trackingParcel.consigneeInformation.address.address1}} {{trackingParcel.consigneeInformation.address.address2}} {{trackingParcel.consigneeInformation.address.address3}}</div>
                <div class="city_info" dataqsi="city">{{trackingParcel.consigneeInformation.address.zipCode}} {{trackingParcel.consigneeInformation.address.city}}</div>
            </div>
        </div>
    </div>
    <div class="informations_delivery" *ngIf="trackingParcel.removalPoint">
        <img class="logo" src="assets/images/picto_livraison_BP.svg" alt="logo BP">
        <div class="body">
            <div class="title">{{"bloc-delivery-informations.pickup" | translate}}</div>
            <div class="informations">
                <div>{{trackingParcel.removalPoint.siteName}}</div>
                <div>{{trackingParcel.removalPoint.address0}} {{trackingParcel.removalPoint.address1}} {{trackingParcel.removalPoint.address2}} {{trackingParcel.removalPoint.address3}}</div>
                <div class="city_info">{{trackingParcel.removalPoint.zipCode}} {{trackingParcel.removalPoint.city}}</div>
            </div>
        </div>
        <div class="opening_hours" *ngIf="count !=0">
            <button mat-icon-button (click)="showOpeningHours()" (click)="generateTagIfOpen()">
                <img class="arrow" [ngStyle]="openingHour ? {'transform': 'scaleY(-1)'} : ''"
                    src="assets/images/arrow-down.svg" alt="arrow" dataqsi="arrow">
            </button>
        </div>
    </div>
    <div class="openingHours" *ngIf="openingHour">
        <app-opening-hours *ngIf="refDeliveryinformation" [refDeliveryinformation]="refDeliveryinformation"></app-opening-hours>
    </div>
</div>
